import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { CLEAR_ERROR } from './types';
import { appLaunchTrack } from '../../application/actions';

const playerClearErrorAction = actionCreator(CLEAR_ERROR);

export const playerClearErrorThunkAction = (error) => (dispatch) => {
  dispatch(playerClearErrorAction(error));
  dispatch(appLaunchTrack(true));
};
